export default [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "DASHBOARD ",
      authRequired: true,
    },
    component: () => import("../views/dashboards/dashboard.vue"),
  },

  {
    path: "/main",
    name: "main",
    meta: {
      title: "SYSTEM CONFIGURATION",
      authRequired: true,
    },
    component: () => import("../views/system/main.vue"),
  },
  {
    path: "/form",
    name: "form",
    meta: {
      title: "MANAGE FORMS",
    },
    component: () => import("../views/system/form.vue"),
  },
  {
    path: "/upload",
    name: "upload",
    meta: {
      title: "Restricted Groups",
    },
    component: () => import("../views/system/upload.vue"),
  },
  {
    path: "/audit",
    name: "audit",
    meta: {
      title: "AUDIT $ LOGS",
    },
    component: () => import("../views/system/audit.vue"),
  },
  {
    path: "/application_management",
    name: "application_management",
    meta: {
      title: "APPLICATION MANAGEMENT",
      authRequired: true,
    },
    component: () => import("../views/application_management/application.vue"),
  },
  {
    path: "/application_cycle",
    name: "application_cycle",
    meta: {
      title: "APPLICATION CYCLE",
      authRequired: true,
    },
    component: () => import("../views/steps/Application_cycle.vue"),
  },
  {
    path: "/step",
    name: "step",
    meta: {
      title: "CREATE NEW APPLICATION",
      authRequired: true,
    },
    component: () => import("../views/steps/appWizard.vue"),
  },

  {
    path: "/applications",
    name: "applications",
    meta: {
      title: "APPLICATIONS",
      authRequired: true,
    },
    component: () => import("../views/steps/applicants.vue"),
  },
  {
    path: "/application",
    name: "application",
    meta: {
      title: "PREVIEW APPLICATION",
      authRequired: true,
    },
    component: () => import("../views/steps/applications.vue"),
  },
  {
    path: "/Edit-application",
    name: "Edit-application",
    meta: {
      title: "EDIT APPLICATION",
      authRequired: true,
    },
    component: () => import("../views/steps/edit_application.vue"),
  },
  {
    path: "/courses",
    name: "courses",
    meta: {
      title: "COURSES",
      authRequired: true,
    },
    component: () => import("../views/courses/main_courses.vue"),
  },
  {
    path: "/courseList",
    name: "courseList",
    meta: {
      title: "COURSE LIST ",
      authRequired: true,
    },
    component: () => import("../views/courses/courseList.vue"),
  },
  {
    path: "/addCourse",
    name: "addCourse",
    meta: {
      title: "ADD COURSES",
      authRequired: true,
    },
    component: () => import("../views/courses/addCourse.vue"),
  },
  {
    path: "/bulk",
    name: "bulk",
    meta: {
      title: "BULK UPLOAD",
      authRequired: true,
    },
    component: () => import("../views/courses/bulkUpload.vue"),
  },
  {
    path: "/review",
    name: "review",
    meta: {
      title: "REVIEW MANAGEMENT",
      authRequired: true,
    },
    component: () => import("../views/review/review_management.vue"),
  },
  {
    path: "/user",
    name: "user",
    meta: {
      title: "USER MANAGEMENT",
      authRequired: true,
    },
    component: () => import("../views/user/user.vue"),
  },
  {
    path: "/parent",
    name: "parent",
    meta: {
      title: "COMMUNICATION MANAGEMENT",
      authRequired: true,
    },
    component: () => import("../views/communication/parent.vue"),
  },
  {
    path: "/communication",
    name: "communication",
    meta: {
      title: "STUDENT MANAGEMENT",
      authRequired: true,
    },
    component: () => import("../views/communication/comm_management.vue"),
  },
  {
    path: "/logs",
    name: "logs",
    meta: {
      title: "Communication Logs",
      authRequired: true,
    },
    component: () => import("../views/communication/logs.vue"),
  },
  {
    path: "/notification",
    name: "notification",
    meta: {
      title: "NOTIFICATION",
      authRequired: true,
    },
    component: () => import("../views/communication/notification.vue"),
  },

  {
    path: "/templates/completed",
    name: "completed",
    meta: {
      title: "SUCCESS",
      authRequired: true,
    },
    component: () => import("../views/communication/success.vue"),
    props: true,
  },
  {
    path: "/templates/incomplete",
    name: "incomplete",
    meta: {
      title: "INCOMPLETE",
      authRequired: true,
    },
    component: () => import("../views/communication/incomplete.vue"),
    props: true,
  },
  {
    path: "/templates/unsuccessful",
    name: "unsuccess",
    meta: {
      title: "UNSUCCESSFUL",
      authRequired: true,
    },
    component: () => import("../views/communication/unsucces.vue"),
    props: true,
  },
  {
    path: "/templates/admission",
    name: "admission",
    meta: {
      title: "ADMISSION",
      authRequired: true,
    },
    component: () => import("../views/communication/admission.vue"),
    props: true,
  },
  {
    path: "/templates/payment",
    name: "payment",
    meta: {
      title: "PAYMENT",
      authRequired: true,
    },
    component: () => import("../views/communication/payment.vue"),
    props: true,
  },
  {
    path: "/student-details",
    name: "student-details",
    meta: {
      title: "STUDENT DETAILS",
      authRequired: true,
    },
    component: () => import("../views/table/student_preview.vue"),
  },
  {
    path: "/reviewers",
    name: "reviews",
    meta: {
      title: "REVIEWS",
      authRequired: true,
    },
    component: () => import("../views/reviewer/review_table.vue"),
  },
  {
    path: "/preview",
    name: "preview",
    meta: {
      title: "PREVIEW",
      authRequired: true,
    },
    component: () => import("../views/reviewer/preview.vue"),
  },
];
